/**
 * AttendanceStatusBadge Component
 * Displays attendance status as a colored chip
 *
 * @version 2025.1.0
 */

import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import {
  AttendanceStatus,
  ATTENDANCE_STATUS_LABELS,
  ATTENDANCE_STATUS_COLORS,
} from '../../../types/reception';

interface AttendanceStatusBadgeProps {
  status: AttendanceStatus;
  size?: 'small' | 'medium';
}

export const AttendanceStatusBadge: React.FC<AttendanceStatusBadgeProps> = ({
  status,
  size = 'small',
}) => {
  const label = ATTENDANCE_STATUS_LABELS[status] || status;
  const color = ATTENDANCE_STATUS_COLORS[status] || 'default';

  return (
    <Chip
      label={label}
      color={color as ChipProps['color']}
      size={size}
      variant="filled"
    />
  );
};

export default AttendanceStatusBadge;
